import { all, call, put, spawn, take } from 'redux-saga/effects';
import * as notify from '../../containers/layout/Notifications/actions';
import { serviceUnavailable } from '../app/actions';
import { ConnectionError, ServiceUnavailableError } from '../app/errors';
import { failure, initializeBetCashInPrice, SUCCESS, success } from './actions';
import getCashInPrices from './rest';

/* eslint-disable no-constant-condition */
function* initializeCashInPrices() {
  while (true) {
    const { results } = yield take(SUCCESS);
    yield put(initializeBetCashInPrice(results[0].betId));
  }
}

export function* fetchCashInPrice(betId) {
  let results;

  try {
    results = yield call(getCashInPrices, [betId]);
    yield put(success(results));
  } catch (e) {
    yield put(failure(e));

    if (e instanceof ConnectionError) {
      yield put(notify.add('Connection error while getting cash in value.', notify.ERROR));
    } else if (e instanceof ServiceUnavailableError) {
      yield put(serviceUnavailable());
    } else {
      throw e;
    }
  }
}

export default function* () {
  yield all([
    spawn(initializeCashInPrices)
  ]);
}
/* eslint-enable no-constant-condition */
